export const getCirclesOfDistrict = (obj) => ({
  type: "GET_CIRCLES_OF_DISTRICT",
  obj,
});

export const getCirclesOfDistrictSuccess = (data) => ({
  type: "GET_CIRCLES_OF_DISTRICT_SUCCESS",
  data,
});

export const getCirclesOfDistrictFail = (error) => ({
  type: "GET_CIRCLES_OF_DISTRICT_FAIL",
  error,
});

export const resetAssignCirclesToTI = (obj) => ({
  type: "RESET_ASSIGN_CIRCLES_TO_TI",
  obj,
});

export const assignCirclesToTI = (obj) => ({
  type: "ASSIGN_CIRCLES_TO_TI",
  obj,
});

export const assignCirclesToTISuccess = (data) => ({
  type: "ASSIGN_CIRCLES_TO_TI_SUCCESS",
  data,
});

export const assignCirclesToTIFail = (error) => ({
  type: "ASSIGN_CIRCLES_TO_TI_FAIL",
  error,
});
